import { Box, Button, makeStyles } from "@material-ui/core";
import { LockOutlined } from "@material-ui/icons";

const useStyle = makeStyles(() => ({
  hoverButton: {
    position: "absolute",
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export default function LockHoverButton({ isShowLock, onBuyTRAVAClick }) {
  const cls = useStyle();

  return (
    <Box className={cls.hoverButton}>
      {isShowLock ? (
        <LockOutlined />
      ) : (
        <Button variant="contained" color="primary" onClick={onBuyTRAVAClick}>
          Buy TRAVA
        </Button>
      )}
    </Box>
  );
}
